import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";
import { STRINGS, type Lang, type StringKey } from "./strings";

type Ctx = {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (key: StringKey) => string;
};

const LanguageCtx = createContext<Ctx | null>(null);
const STORAGE_KEY = "lang";

// Sprachumschalter ist aktuell ausgeblendet; Default-Sprache wird auf
// Deutsch erzwungen, auch falls im localStorage noch "en" hinterlegt ist.
// Wenn der Schalter wieder aktiviert wird, kann die alte Hydration unten
// (auskommentiert) reaktiviert werden.
function readInitial(): Lang {
  return "de";
  // if (typeof window === "undefined") return "de";
  // try {
  //   const v = window.localStorage.getItem(STORAGE_KEY);
  //   if (v === "de" || v === "en") return v;
  // } catch {}
  // return "de";
}

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>("de");

  // Hydrate from localStorage on client
  useEffect(() => {
    setLangState(readInitial());
  }, []);

  const setLang = (l: Lang) => {
    setLangState(l);
    if (typeof window !== "undefined") {
      try { window.localStorage.setItem(STORAGE_KEY, l); } catch {}
    }
  };

  const value = useMemo<Ctx>(() => ({
    lang,
    setLang,
    t: (key) => STRINGS[key]?.[lang] ?? STRINGS[key]?.de ?? key,
  }), [lang]);

  return <LanguageCtx.Provider value={value}>{children}</LanguageCtx.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageCtx);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}

export function useT() {
  return useLang().t;
}
